<template>
    <v-layout>
        <v-layout wrap>
            <v-flex xs12 pt-2 pl-4 class="m-onboard-step-objects__texts">
                <e-typography-body-small>{{$t('modules.onboards.m-onboard-step-ra.first-text')}}</e-typography-body-small>
            </v-flex>
            <v-flex xs12 class="m-onboard-step-ra__btn-action">
                <e-button-primary :loading="commonLoading" class="mr-0" tabindex="0" @click="start_risk_assessment">
                    {{$t('modules.onboards.m-onboard-step-ra.button')}}
                </e-button-primary>
            </v-flex>
            <v-flex xs12 pl-4 class="m-onboard-step-ra__texts">
                <e-typography-body-small>{{$t('modules.onboards.m-onboard-step-ra.second-text')}}</e-typography-body-small>
            </v-flex>
        </v-layout>
        <div class="m-onboard-step-buttons-wrap">
            <div class="m-onboard-step-buttons ra-buttons">
                <e-button-white :loading="commonLoading" class="mr-0" tabindex="0" @click="start_risk_assessment">
                    {{$t('modules.onboards.m-onboard-step-ra.button')}}
                </e-button-white>
            </div>
        </div>
    </v-layout>


</template>



<script>

    // IE11 Fix
    if (!('remove' in Element.prototype)) {
        Element.prototype.remove = function() {
            if (this.parentNode) {
                this.parentNode.removeChild(this);
            }
        };
    }

    import {mapActions} from "vuex";
    import EButtonPrimary from "@elements/buttons/theme/e-button-primary";

    export default {
        name: "m-onboard-step-ra",
        components: {EButtonPrimary},
        props: [ 'objectId' ],
        data(){
            return {
                commonLoading: false
            }
        },
        methods: {
            ...mapActions({
                requestCreateAssessment: 'riskAssessments/create'
            }),
            async createAssessment() {
                return await this.requestCreateAssessment(this.objectId)
            },
            async start_risk_assessment() {
                try {
                    this.setCommonLoading(true);
                    const newRa = await this.createAssessment();
                    this.setCommonLoading(false);
                    this.redirect(this.nav.dashboard.service.onboarding_risk_assessment.view.name, {
                        id: newRa._id
                    });
                } catch (e) {
                    this.setCommonLoading(false);
                    if (e.response && e.response.status === 404) {
                        this.notify.error(e.response.data.detail)
                    } else {
                        this.error.handle(e)
                    }
                }
            },
            setCommonLoading(loading){
                this.commonLoading = loading
            },
            next() {
                this.$emit('next')
            },
            placeButtons() {
                let removeButtons = document.querySelector('.object-buttons');
                let addButtons = document.querySelector('.ra-buttons');
                let target = document.querySelector('.m-onboard-header-buttons');
                if(document.body.contains(removeButtons)) removeButtons.remove();
                target.appendChild(addButtons)
            }
        },
        mounted() {
            this.placeButtons();
        },
        updated(){
            this.placeButtons()
        },
    }
</script>

<style lang="scss" scoped>
    .m-onboard-step-ra {
        .v-expansion-panel {
            &__body {
                background: var(--v-secondary-base);
            }
        }
        &__btn-action {
            @include media(md) {
                padding-right: 2rem !important;
            }
        }
    }
</style>